<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm @submit="onRegister" autocomplete="off">
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <CInput
                  name="name"
                  placeholder="Full Name"
                  autocomplete="off"
                  :value="inputFields.name"
                  :isValid="!errorFields.name ? null : false"
                  :invalidFeedback="errorFields.name"
                  @input="onInputChange"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  name="email"
                  placeholder="Email"
                  autocomplete="off"
                  prepend="@"
                  :isValid="!errorFields.email ? null : false"
                  :invalidFeedback="errorFields.email"
                  @input="onInputChange"
                />
                <CInput
                  name="password"
                  placeholder="Password"
                  type="password"
                  autocomplete="off"
                  :isValid="!errorFields.password ? null : false"
                  :invalidFeedback="errorFields.password"
                  @input="onInputChange"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CInput
                  name="password_confirmation"
                  placeholder="Repeat password"
                  type="password"
                  autocomplete="off"
                  class="mb-4"
                  :isValid="!errorFields.password_confirmation ? null : false"
                  :invalidFeedback="errorFields.password_confirmation"
                  @input="onInputChange"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol>
                    <CButton v-if="!isRequesting" @click="onRegister" color="success" block>Create Account</CButton>
                    <preloader v-if="isRequesting" text="Registering..." />
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
            <CCardFooter class="p-4">
              <CRow>
                <p>Already have and account? <CLink to="/login">Login Here</CLink></p>
              </CRow>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import authRegister from '@/services/authRegister'
export default {
  name: 'Register',
  title: 'Register',
  data () {
    return {
      inputFields: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      errorFields: {},
      isRequesting: !1
    }
  },
  methods: {
    onInputChange (value, e) {
      const { target: { name } } = e
      this.inputFields = { ...this.inputFields, [name]: value }
      this.errorFields = { ...this.errorFields, [name]: '' }
    },
    async onRegister () {
      this.errorFields = {}
      this.isRequesting = !0
      const {
        type,
        user,
        message,
        errorFields
      } = await authRegister(this.inputFields)
      if (type === 200) {
        this.$store.commit('ADD_LOGGED_USER_DATA', user)
        this.$store.commit('ADD_NOTIFICATION', { type: 'success', message })
        this.$router.push({ name: 'Dashboard' })
        return
      }
      this.isRequesting = !1
      if (type === 422) {
        this.errorFields = errorFields
        return
      }
      this.$store.commit('ADD_NOTIFICATION', { type: 'error', message })
    }
  }
}
</script>
